import serverNativeBehaviorEvaluator from './serverNativeBehaviorEvaluator';

// cache for behaviors - don't refetch if we have already loaded.
const behaviors = {};

// this list should look like the contents of 'server/models/content/nativeBehaviors'
// minus any web native behaviors listed in 'web/src/js/nativeBehaviors'
const serverBehaviors = ['addFormBehavior', 'addFormsBehavior',
// 'aiPromptBehavior', // web native behavior
// 'aiDocumentParseBehavior', // web native behavior
'aiSummaryBehavior', 'autoAssociatedDocumentsBehavior', 'bulkAddFormsBehavior', 'cabinetCsvExportBehavior', 'cabinetCsvExportColumnsBehavior', 'cabinetCsvExportColumnOptionsBehavior', 'cabinetCsvExportCountBehavior', 'bulkExportBehavior', 'bulkDeleteFormsBehavior',
// 'checkPermissionBehavior', // web native behavior
// 'clientInfoBehavior', // web native behavior
'contractRequirementsBehavior', 'contractSpecBehavior', 'customerBehavior',
// 'csvImportGetUnselectedMappedContentPathOptionsBehavior', // web native behavior
// 'csvImportValidSelectionMappingsExistBehavior', // web native behavior
'docRipperAssociatePagesBehavior', 'docRipperQueryPotentialMatchesBehavior', 'employeesBehavior', 'enqueueTaskBehavior', 'extractArbitraryLogContentPathBehavior', 'extractAuditTrailBehavior', 'generateErrorBehavior',
// 'getCacheValueBehavior', // web native behavior
'getContentPathOptionsForTaggedComponentsBehavior', 'getCustomersBehavior',
// 'getFormContentBehavior', // web native behavior with caching
// 'getUserPermissionsBehavior', // web native behavior
// 'isCurrentUserCreatorBehavior', // web native behavior
'getLogContentPathBehavior', 'getSignedUrlBehavior', 'getSignedUrlForPathBehavior', 'invalidateErrorTypeMatchCacheBehavior', 'jobReferenceBehavior', 'joinTableBehavior', 'loadUserPreferencesFavoritesBehavior',
// 'llmBehavior', // web native behavior
'patchContentBehavior', 'performOnServerBehavior', 'previousFormBehavior',
// 'queryEntityBehavior', // web native behavior with caching
// 'queryFormBehavior', // web native behavior with caching
'queryReportsBehavior', 'readJobContentBehavior', 'recentAuditedFormsBehavior', 'reportFormIndexBehavior', 'sendEmailBehavior', 'sendSlackMessageBehavior', 'sudoBehavior',
// 'setCacheValueBehavior', // web native behavior
'taggedOptionsBehavior', 'trcPipeSpecInventoryBehavior', 'trcPipeYardInventoryBehavior', 'tvcAssetCountBehavior', 'tvcGetItemsForCheckBehavior', 'tvcProjectsBehavior', 'updateAssociatedDocumentsBehavior', 'updateChecklistItemBehavior', 'updateColumnBehavior', 'updateForeignKeyBehavior', 'updateJoinTableBehavior', 'updatePiecesBehavior', 'updateReportAssetAssociationsBehavior', 'userSyncBehavior'];

/**
 * get the module for a given behavior name.  if it does not exist, it
 * will throw an error.
 */
const getBehavior = behaviorName => {
  if (behaviors[behaviorName] !== undefined) {
    return behaviors[behaviorName];
  }
  const behavior = serverBehaviors.includes(behaviorName)
  /* eslint-disable-next-line import/no-dynamic-require, global-require */ ? serverNativeBehaviorEvaluator : require("./".concat(behaviorName));
  behaviors[behaviorName] = behavior;
  return behavior;
};

/**
 * return true if behavior exists.
 */
export const behaviorExists = behaviorName => {
  try {
    const module = getBehavior(behaviorName);
    return module !== undefined;
  } catch (err) {
    return false;
  }
};

/**
 * @method nativeBehaviorEvaluator
 * will be passed to behaviors to evaluate any behaviors that must be
 * evaluated outside of the behaviors repo.  E.g. redux store access is an example where we want
 * to access data "natively", but store the results in the content.
 *
 * it is important to note that this method utilizes both the `async/await` and `callback` approach
 * to resolve. first, the `callback` argument is provided from the `behaviors` project in a classic
 * node.js style: return two parameters, `error, result`. this is necessary since the `behavior`
 * project is used on multiple clients (web, server, ios) and the ios project specifically requires
 * the use of a callback.
 * `async/await` is also utilized in this method to deal with
 * any asynchronous calls in a given
 * nativeBahavior.evaluate method. these methods may involve
 * database reads, so they must be invoked
 * before calling the provided callback method.
 */
export const nativeBehaviorEvaluator = async (entity, entityName, format, content, parentContentPath, transientContext, nativeFunctions, callback, sourceEvaluator) => {
  // look for the name in the source spec, and use that to determine what to do.
  let result;
  try {
    // Need to use dynamic require to avoid recurssion issues
    // as this is the base class for the other behaviors
    let behavior;
    try {
      behavior = getBehavior(format.type);
    } catch (err) {
      return callback({
        statusCode: 404,
        message: "NativeBehavior ".concat(format.type, " does not exist:  ").concat(err.message)
      });
    }
    const _behavior = behavior,
      evaluate = _behavior.evaluate;
    result = await evaluate(entity, entityName, format, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator);
    return callback(null, result);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn("error ".concat(e.message, " \n    ").concat(e.stack));
    return callback(new Error("NativeBehavior ".concat(format.type, " error:  ").concat(e.message)));
  }
};